/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import { css } from '@emotion/react';
import { N20 } from '@atlaskit/theme/colors';
export const overflowShadow = ({
  leftCoverWidth,
  rightCoverWidth
}) => {
  const width = "var(--ds-space-100, 8px)";
  const leftCoverWidthResolved = leftCoverWidth || width;
  const rightCoverWidthResolved = rightCoverWidth || width;

  // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
  return css`
/* shadow cover left */
  linear-gradient(
    to right,
    ${`var(--ds-background-neutral, ${N20})`} ${leftCoverWidthResolved},
    transparent ${leftCoverWidthResolved}
  ),
/* shadow cover background left */
  linear-gradient(
    to right,
    ${"var(--ds-surface-raised, transparent)"} ${leftCoverWidthResolved},
    transparent ${leftCoverWidthResolved}
  ),
/* shadow cover right */
  linear-gradient(
    to left,
    ${`var(--ds-background-neutral, ${N20})`} ${rightCoverWidthResolved},
    transparent ${rightCoverWidthResolved}
  ),
/* shadow cover background right */
  linear-gradient(
    to left,
    ${"var(--ds-surface-raised, transparent)"} ${rightCoverWidthResolved},
    transparent ${rightCoverWidthResolved}
  ),
/* overflow shadow right spread */
  linear-gradient(
    to left,
    ${"var(--ds-shadow-overflow-spread, rgba(9, 30, 66, 0.13))"} 0,
    ${"var(--ds-UNSAFE-transparent, rgba(99, 114, 130, 0))"}  ${width}
  ),
  /* overflow shadow right perimeter */
  linear-gradient(
    to left,
    ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0,
    ${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
  ),
  /* overflow shadow left spread */
  linear-gradient(
    to right,
    ${"var(--ds-shadow-overflow-spread, rgba(9, 30, 66, 0.13))"} 0,
    ${"var(--ds-UNSAFE-transparent, rgba(99, 114, 130, 0))"}  ${width}
  ),
  /* overflow shadow left perimeter */
  linear-gradient(
    to right,
    ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0,
    ${"var(--ds-UNSAFE-transparent, transparent)"}  ${width}
  )
`;
};